import Application from "../../Application";
import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";
import { IReportingTypeService } from "../../service/reporting/ReportingTypeService";
import ReportingPeriodPresenter, {
  IReportingPeriodPresenter
} from "../../presenter/reporting/ReportingPeriodPresenter";
import { ISystemParameterService } from "../../service/systemparameter/SystemParameterService";
import { SystemParameterConstants } from "../../common/Constants";

export default class ShowReportingPeriodsInteractor {
  private application: Application;
  private output?: IReportingPeriodPresenter;
  private reportingPeriodService: IReportingPeriodService;
  private reportingTypeService: IReportingTypeService;
  private systemParameterService: ISystemParameterService;

  constructor(
    application,
    reportingPeriodService,
    reportingTypeService,
    systemParameterService
  ) {
    this.application = application;
    this.reportingPeriodService = reportingPeriodService;
    this.reportingTypeService = reportingTypeService;
    this.systemParameterService = systemParameterService;
  }

  private async getReportingData() {
    const reportingPeriods = await this.reportingPeriodService.getReportingPeriods();
    const reportingTypes = await this.reportingTypeService.getReportingTypes();
    const percentage = await this.systemParameterService.getNumber(
      SystemParameterConstants.PERCENTAGE_OF_CANDIDATES
    );

    return { reportingPeriods, reportingTypes, percentage };
  }

  execute() {
    this.output = ReportingPeriodPresenter({
      application: this.application,
      initialState: {
        reportingPeriods: [],
        reportingTypes: [],
        applicantAssignationDialogVisible: false,
        randomSelectionDialogVisible: false,
        confirmRandomSelectionDialogVisible: false
      }
    });

    this.getReportingData().then(
      (result) =>
        this.output &&
        this.output.load(
          result.reportingPeriods,
          result.reportingTypes,
          result.percentage
        )
    );

    return this.output;
  }
}
